import script from "./EssayCorrection.vue?vue&type=script&setup=true&lang=js"
export * from "./EssayCorrection.vue?vue&type=script&setup=true&lang=js"

import "./EssayCorrection.vue?vue&type=style&index=0&id=3925e510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3925e510"]])

export default __exports__